<template>
    <div class="home-bg">
        <header-div />
        <section class="home-container">
            <div class="form-container">
                <div class="form-box">
                    <div>
                        <h1>
                            Insira seu e-mail para recuperar sua senha.
                        </h1>
                        <p>
                            Em seguida você receberá um e-mail contendo um link para inserir sua nova senha.
                        </p>
                    </div>
                    <form @submit="handleSubmit">
                        <div class="input-box">
                            <label for="email">E-mail *</label>
                            <input
                            type="text"
                            name="email"
                            id="email"
                            v-model="form.email"/>
                            <small class="error" v-if="errors && errors.email">{{errors.email.join()}}</small>
                        </div>
                        <div class="form-actions" v-if="!confirmed">
                            <button v-if="!loading" class="button btn-orange">
                                RECUPERAR
                            </button>
                            <button v-if="loading" class="button btn-orange" disabled>
                                <loading />
                            </button>
                        </div>
                        <div class="form-actions" v-if="confirmed">
                            <p>Foi enviado para o seu e-mail um link para redefinir sua senha.</p>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import { FORGOT_PASSWORD } from '../../services/user'
    import { User } from '../../models/User'

    export default {
        components: {  },
        data() {
            return {
                showRegisterModal: false,
                forgotPasswordUrl: "",
                showPassword: false,
                loading: false,
                form: {
                    email: null,
                    password: null,
                    remember: false,
                },
                confirmed: false,
            }
        },
        methods: {
            clearErrors() {
                this.errors = [];
            },
            handleShowPassword() {
                this.showPassword = !this.showPassword;
                const password = document.getElementById('password');
                if(this.showPassword){
                    password.type = "text";
                }else{
                    password.type = "password";
                }
            },
            async handleSubmit(event) {
                event.preventDefault();
                this.clearErrors();
                this.loading = true;
                FORGOT_PASSWORD(this.form).then(
                    resp => {
                        this.confirmed = true;
                    },
                    error => this.errors = error.response.data.errors,
                    ).then(
                    resp => {
                        this.loading = false;
                    }
                );
            },
        },
        mounted() {
            
        }
    }
</script>

<style scoped>
    @import "../Home/home.scss";
    @import "../Home/responsive.css";
</style>


// WEBPACK FOOTER //
// src/views/ForgotPassword/ForgotPassword.vue